import React, { useState } from 'react'
import { Popover, PopoverTrigger, PopoverContent } from '../Popover'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../Tooltip'

export type ColorPickerProps = {
  // showColorPicker: boolean;
  palette?: {
    color: string
    name: string
    value: string
  }[]
  color: string
  handleChange?: (
    color: string,
    e?: React.ChangeEvent<HTMLInputElement>,
  ) => Promise<void> | void
}

const defaultColorPalette = [
  '#E91E63',
  '#9C27B0',
  '#3F51B5',
  '#03A9F4',
  '#009688',
  '#F06292',
  '#8BC34A',
  '#FFEB3B',
  '#FF9800',
  '#795548',
]

const ColorPicker = (props: ColorPickerProps) => {
  const { palette, color, handleChange } = props

  const [open, setOpen] = useState(false)

  const colorPickerRef = React.useRef(null)

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        colorPickerRef.current &&
        !(colorPickerRef.current as any).contains(event.target)
      ) {
        // Clicked outside the color picker, so close it
        setOpen(false)
      }
    }

    // Add event listener when component mounts
    document.addEventListener('mousedown', handleClickOutside)

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [colorPickerRef])

  return (
    <Popover open={open}>
      <TooltipProvider>
        <PopoverTrigger
          style={{ backgroundColor: color }}
          onClick={() => setOpen((prev) => !prev)}
          className="rounded-full w-4 h-4"
        />
        <PopoverContent
          className="w-32 grid grid-cols-5 grid-row-2 place-items-center p-2"
          ref={colorPickerRef}
        >
          {palette
            ? palette.map((c, i) => {
                return (
                  <Tooltip key={i} delayDuration={100}>
                    <TooltipTrigger asChild>
                      <button
                        className="w-4 h-4 rounded-full my-2"
                        style={{ backgroundColor: c.color }}
                        onClick={() => {
                          setOpen(false)
                          if (handleChange) {
                            handleChange(c.color, {
                              target: { value: c.value },
                            } as React.ChangeEvent<HTMLInputElement>)
                          }
                        }}
                      />
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>{c.name}</p>
                    </TooltipContent>
                  </Tooltip>
                )
              })
            : defaultColorPalette.map((c, i) => {
                return (
                  <Tooltip key={i} delayDuration={100}>
                    <TooltipTrigger asChild>
                      <button
                        className="w-4 h-4 rounded-full my-2"
                        style={{ backgroundColor: c }}
                        onClick={() => {
                          setOpen(false)
                          if (handleChange) {
                            handleChange(c, {
                              target: { value: c },
                            } as React.ChangeEvent<HTMLInputElement>)
                          }
                        }}
                      />
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>{c}</p>
                    </TooltipContent>
                  </Tooltip>
                )
              })}
        </PopoverContent>
      </TooltipProvider>
    </Popover>
  )
}

export default ColorPicker
